<template>
  <div class="input">
    <div class="input-label">誕生日</div>
    <div class="input-group">
      <input
        type="number"
        :min="1900"
        class="input-text"
        v-model="birthDayYear">
      <div class="input-label_after">年</div>
      <input
        type="number"
        min="1"
        max="12"
        class="input-text"
        v-model="birthDayMonth">
      <div class="input-label_after">月</div>
      <input
        type="number"
        min="1"
        max="31"
        class="input-text"
        v-model="birthDayDate">
      <div class="input-label_after">日</div>
    </div>
  </div>


</template>

<script>
export default {
  computed: {
    birthDayYear: {
      get: function () {
        return this.$store.state.user.birthDayYear
      },
      set: function (value) {
        this.$store.commit(
          'user/setBirthDayYear',
          value
        )
      }
    },

    birthDayMonth: {
      get: function () {
        return this.$store.state.user.birthDayMonth
      },
      set: function (value) {
        this.$store.commit(
          'user/setBirthDayMonth',
          value
        )
      }
    },

    birthDayDate: {
      get: function () {
        return this.$store.state.user.birthDayDate
      },
      set: function (value) {
        this.$store.commit(
          'user/setBirthDayDate',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
